// Code review - Completed
// Documentation - Completed
import { useState, useEffect } from "react";
import { cityvillageMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import CityVillagePopup from "../popup-containers/CityVillagePopup";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";

const CityVillageMaster = () => {
  const location1 = useLocation();
  //All bind dropdown value and bind data value useState hooks handling.

  const { userProfileState } = useUserCapability();
  const [bindStateDropDown, setBindStateDropDown] = useState([]);
  const [bindCityMasterDatas, setBindCityMasterDatas] = useState([]);
  const [getDistrictDatas, setGetDistrictDatas] = useState([]);
  const [bindDistrict, setBindDistrict] = useState([]);
  const [bindDistrict1, setBindDistrict1] = useState([]);
  const [getBlockDatas, setGetBlockDatas] = useState([]);
  const [bindBlock, setBindBlock] = useState([]);
  const [bindBlock1, setBindBlock1] = useState([]);

  //All visible functionality useState hooks handling.
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // SDP Master insert and edit useState hooks handling .
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");

  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");
  const [blockError, setBlockError] = useState("");

  const [districtError, setDistrictError] = useState("");
  const [mstCityVillageId, setMSTCityVillageId] = useState("");

  const createdBy = sessionStorage.getItem("createdBy");

  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  const [blockMasterDatas, setBlockMasterData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    CityMasterData();
    setState("");
    setDistrict("");
    setDistrictError("");
    setStateError("");
    setBlock("");
    setBlockError("");
    setCity("");
    setCityError("");
    setIsLoading(false);
  };

  // ✅ Common filter helper
  const filterBlocked = (data) =>
    (data || []).filter((item) => item.BlockedBy === null);

  useEffect(() => {
    CityMasterData();
  }, []);
  const CityMasterData = async () => {
    try {
      setIsLoading(true);

      const [statesRes, districtRes, blockRes, cityRes] = await Promise.all([
        BindAPI("StateAPI/GetState"),
        BindAPI("IECAPI/BindDistrict"),
        BindAPI("IECAPI/BindBlock"),
        BindAPI("CityVillageAPI/BindCityVillageMaster"),
      ]);

      // ✅ States dropdown
      const statesData = filterBlocked(statesRes?.data?.Table).map((item) => ({
        value: item.MstStateId,
        label: item.StateName_en,
      }));
      setBindStateDropDown(statesData);

      // ✅ District dropdown
      const districtData = filterBlocked(districtRes?.data?.Table).map(
        (item) => ({
          value: item.MstDistrictId,
          label: item.District_en,
        }),
      );
      setBindDistrict1(districtData);
      setGetDistrictDatas(districtRes?.data?.Table || []);

      // ✅ Block dropdown
      const blockData = filterBlocked(blockRes?.data?.Table).map((item) => ({
        value: item.MstBlockId,
        label: item.Block_en,
      }));
      setBindBlock1(blockData);
      setGetBlockDatas(blockRes?.data?.Table || []);

      const userProfileDatas = userProfileState.userProfile;
      const mstStateId = userProfileDatas[0]?.MstStateId;
      const orgStructureId = userProfileDatas[0]?.MstOrganizationId;
      var filteredData = [];
      if (orgStructureId == 1) {
        filteredData = cityRes?.data?.Table;
      } else {
        filteredData = cityRes?.data?.Table?.filter(
          (item) => item?.MstStateId === mstStateId,
        );
      }

      setBindCityMasterDatas(filteredData || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setState(bindCityMasterDatas[rowIndex].MstStateId);
    setDistrict(bindCityMasterDatas[rowIndex].MstDistrictId);
    setMSTCityVillageId(bindCityMasterDatas[rowIndex].MstCityId);
    setBlock(bindCityMasterDatas[rowIndex].MstBlockId);
    setCity(bindCityMasterDatas[rowIndex].City_en);
  };

  const handleBlock = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setBlockMasterData(bindCityMasterDatas[rowIndex]);
    const CityData = bindCityMasterDatas[rowIndex];
    //State DropDown Value Start
    const stateDropDownValue = bindStateDropDown.find(
      (item) => item.value === CityData.MstStateId,
    );
    const editStateDropDownValue = {
      value: CityData.MstStateId,
      label: stateDropDownValue ? stateDropDownValue.label : "Unknown",
    };
    //State DropDown Value End

    //District DropDown Value Start
    const DistrictDropDownValue = bindDistrict1.find(
      (item) => item.value === CityData.MstDistrictId,
    );
    const editDistrictDropDownValue = {
      value: CityData.MstDistrictId,
      label: DistrictDropDownValue ? DistrictDropDownValue.label : "Unknown",
    };
    //District DropDown Value End

    //Block DropDown Value Start
    const BlockDropDownValue = bindBlock1.find(
      (item) => item.value === CityData.MstBlockId,
    );
    const editBlockDropDownValue = {
      value: CityData.MstBlockId,
      label: BlockDropDownValue ? BlockDropDownValue.label : "Unknown",
    };
    //Block DropDown Value End

    const autoDropDownValues = [
      editStateDropDownValue,
      editDistrictDropDownValue,
      editBlockDropDownValue,
    ];
    setPopUpDropDownData(autoDropDownValues);
  };

  const cityVillageExcelHeader = [
    { title: "S.No" },
    { title: "MstCityId" },
    { title: "Country" },
    { title: "State" },
    { title: "District" },
    { title: "Block" },
    { title: "City / Village_en" },
    { title: "City / Village_ta" },
    { title: "City / Village_hi" },
    { title: "City / Village_mr" },
    { title: "City / Village_gu" },

    { title: "City / Village_kn" },
    { title: "City / Village_ml" },

    { title: "City / Village_te" },
    { title: "City / Village_bn" },
    { title: "City / Village_or" },
    { title: "Created By" }, // ✅ instead of Action
  ];

  const handleExport = async () => {
    try {
      const cityVillageResponse = await BindAPI(
        "CityVillageAPI/BindCityVillageMasterExcel",
      );

      const userProfileDatas = userProfileState?.userProfile || [];
      const mstStateId = userProfileDatas[0]?.MstStateId;
      const orgStructureId = userProfileDatas[0]?.MstOrganizationId;

      let rows = []; // ✅ changed to let

      const tableData = cityVillageResponse?.data?.Table || [];

      if (orgStructureId === 1) {
        rows = tableData;
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "CITY/VILLAGE MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_city_village",
            description: `City/Village Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      } else {
        rows = tableData.filter((item) => item?.MstStateId === mstStateId);
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "CITY/VILLAGE MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_city_village",
            description: `City/Village Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "CITY/VILLAGE MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_city_village",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }

      // ✅ pass only string headers
      exportCityVillageData(
        cityVillageExcelHeader.map((col) => col.title),
        rows,
      );
    } catch (error) {
      console.error("City / Village Excel Export Error:", error);
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "CITY/VILLAGE MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_city_village",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog",
      );
      toast.error("Failed to export City / Village data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportCityVillageData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "City / Village Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const style = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: style }, // S.No
        { v: row.MstCityId, s: style }, // Country
        { v: row.CountryName_en, s: style }, // Country
        { v: row.StateName_en, s: style }, // State
        { v: row.District_en, s: style }, // District
        { v: row.Block_en, s: style }, // Block
        { v: row.City_en, s: style }, // City / Village       // Block
        { v: row.City_ta, s: style }, // Block
        { v: row.City_hi, s: style }, // Block
        { v: row.City_bn, s: style }, // Block
        { v: row.City_kn, s: style }, // Block
        { v: row.City_ml, s: style }, // Block
        { v: row.City_gu, s: style }, // Block
        { v: row.City_mr, s: style }, // Block
        { v: row.City_te, s: style }, // Block
        { v: row.City_or, s: style },
        { v: row.CreatedByName, s: style }, // Created By
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { width: 5 }, // S.No
      { width: 20 }, // Country
      { width: 20 }, // Country
      { width: 25 }, // State
      { width: 25 }, // District
      { width: 25 }, // Block
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // City / Village
      { width: 30 }, // Created By
    ];

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "City Village Master");
    XLSX.writeFile(wb, "City_Village_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // validation start
      let stateValidate = "";
      let districtValidate = "";
      let blockValidate = "";
      let cityValidate = "";

      cityValidate = city ? "" : "Enter City";

      stateValidate = state ? "" : "Select a State";
      districtValidate = district ? "" : "Select a District";
      blockValidate = block ? "" : "Select a Block";
      setBlockError(blockValidate);
      setStateError(stateValidate);
      setDistrictError(districtValidate);
      setCityError(cityValidate);
      if (stateValidate || districtValidate || blockValidate || cityValidate) {
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
      // Validation end

      if (
        !stateValidate &&
        !districtValidate &&
        !blockValidate &&
        !cityValidate
      ) {
        setIsOpen(false);
        // const languageKeys = [
        //   "ta", // Tamil
        //   "hi", // Hindi
        //   "mr", // Marathi
        //   "gu", // Gujarati
        //   "kn", // Kannada
        //   "ml", // Malayalam
        //   "te", // Telugu
        //   "bn", // Bengali
        //   "or", // Oriya
        // ];
        // const translatedTexts = [];
        // for (let i of languageKeys) {
        //   const translateText = await LanguageTranslatorAPI(city, i);
        //   translatedTexts.push(
        //     translateText.data.data.translations[0].translatedText
        //   );
        // }
        const data = [
          {
            mstCityId: mstCityVillageId ? mstCityVillageId : 0,
            mstCountryId: 1,
            mstStateId: state,
            mstDistrictId: district,
            mstBlockId: block,
            city_en: city,
            city_ta: city,
            city_hi: city,
            city_mr: city,
            city_gu: city,
            city_kn: city,
            city_ml: city,
            city_te: city,
            city_bn: city,
            city_or: city,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(data, "CityVillageAPI/IUDCityVillage");
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("City / Village data added successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to add City / Village data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("City / Village data updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update City / Village data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = [
        {
          mstCityId: bindCityMasterDatas[items].MstCityId,
          createdBy: createdBy,
          flag: flag,
        },
      ];
      const response = await IUDAPI(data, "CityVillageAPI/IUDCityVillage");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].Result === "D") {
          toast.success("City / Village data deleted successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to delete City / Village data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].Result === "B") {
          toast.success("City / Village data blocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to block City / Village data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].Result === "UB") {
          toast.success("City / Village data unblocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to unblock City / Village data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };
  useEffect(() => {
    if (location1.pathname == "/cityvillagemaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location1]);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getDistrictDatas.find(
      (item) => item.MstStateId == state, // Replace with the desired MstStateId
    );
    setBindDistrict([]);
    if (stateSelectedValue) {
      const districtLabels = getDistrictDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstDistrictId: item.MstDistrictId,
          District_en: item.District_en,
        }));

      const districtSelected = districtLabels.map((LC) => ({
        value: LC.MstDistrictId, // Replace with the appropriate value
        label: LC.District_en,
      }));
      setBindDistrict(districtSelected);
    } else {
    }
  }, [state]);

  useEffect(() => {
    const BlockSelectedValue = getBlockDatas.find(
      (item) => item.MstDistrictId == district, // Replace with the desired MstStateId
    );
    setBindBlock([]);
    if (BlockSelectedValue) {
      const blockLabels = getBlockDatas
        .filter(
          (item) => item.MstDistrictId === BlockSelectedValue.MstDistrictId,
        )
        .map((item) => ({
          MstBlockId: item.MstBlockId,
          Block_en: item.Block_en,
        }));

      const blockSelected = blockLabels.map((SD) => ({
        value: SD.MstBlockId, // Replace with the appropriate value
        label: SD.Block_en,
      }));
      setBindBlock(blockSelected);
    } else {
    }
  }, [district]);

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"City / Village Master"}
          header={cityvillageMasterHeader}
          records={bindCityMasterDatas}
          handleEdit={handleEdit}
          handleExportBtn={true}
          handleExport={handleExport}
          handleAction={handleBlock}
          showAdd={showadd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <div class="border-black">
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="City / Village Master"
            />
          </div>
          <div class="mx-auto md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <AutoDropDown
                      classStar="text-red-500"
                      classDiv="hidden"
                      title={"Country"}
                      options={[]}
                      selectedOption={country}
                      placeholder={"Select"}
                      name={"country"}
                      controlFunc={(value) => {
                        setCountry(value);
                      }}
                      Class="custom-class"
                      disabled="false"
                      tabIndex="1"
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="State"
                      options={bindStateDropDown}
                      placeholder="Select"
                      name="state"
                      selectedOption={bindStateDropDown.find(
                        (x) => x.value == state,
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setBlock("");
                        setDistrict("");
                        setState(value.value);
                        setStateError(value ? "" : "Select a State");
                      }}
                      controlFuncBlur={() => {
                        setStateError(state ? "" : "Select a State");
                      }}
                      errorMessage={stateError?.stateError}
                      setError={setStateError}
                    />

                    <AutoDropDown
                      classStar="text-red-500"
                      title="District"
                      options={bindDistrict}
                      placeholder="Select"
                      name="District"
                      selectedOption={
                        district
                          ? bindDistrict.find((x) => x.value == district)
                          : ""
                      }
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setBlock("");
                        setDistrict(value.value);
                        setDistrictError(value ? "" : "Select a District");
                      }}
                      controlFuncBlur={() => {
                        setDistrictError(district ? "" : "Select a District");
                      }}
                      errorMessage={districtError?.districtError}
                      setError={setDistrictError}
                    />

                    <AutoDropDown
                      classStar="text-red-500"
                      title="Block"
                      options={bindBlock}
                      placeholder="Select"
                      name="block"
                      selectedOption={
                        block ? bindBlock.find((x) => x.value == block) : ""
                      }
                      Class="custom-class"
                      tabIndex="1"
                      controlFunc={(value) => {
                        setBlock(value.value);
                        setBlockError(value ? "" : "Select a Block");
                      }}
                      controlFuncBlur={() => {
                        setBlockError(block ? "" : "Select a Block");
                      }}
                      errorMessage={blockError?.blockError}
                      setError={setBlockError}
                    />

                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title="City / Village"
                      name={"city"}
                      maxLength={100}
                      content={city}
                      controlFunc={(e) => setCity(e.target.value)}
                      controlFuncBlur={() => {
                        const trimmedValue = city?.trim(); // Remove leading/trailing spaces
                        setCityError(
                          trimmedValue.length > 0 ? "" : " Enter City",
                        );

                        setCity(trimmedValue);
                      }}
                      errorMessage={cityError}
                    />
                  </form>
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleBlock}
      >
        <div>
          <PopUpScreenTitle
            title="City / Village Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <CityVillagePopup data={blockMasterDatas} data2={popUpDropDownData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default CityVillageMaster;
